/**
 * MER-01 policy: optional merchant reads soft-fail on **404 only**.
 * Do not broaden to 403/5xx — that hides PERM/API honesty failures.
 */
export function isOptionalReadMiss(status: number): boolean {
  return status === 404;
}

export function emptyListPayload(key: string): { data: Record<string, unknown[]> } {
  return { data: { [key]: [] } };
}
